import { useParams } from "react-router-dom";

import { Layout } from "./Layout";

export function TicketDetailsPage({ ticketId }: { ticketId?: string }): React.ReactNode {
  const { id: paramsTicketId } = useParams<{ id: string }>();

  return <Layout ticketId={(ticketId || paramsTicketId)!} />;
}
